export default {
  namespaced: true,

  state: {
    data: {},
    meta: {},
    loading: false,
    error: null,
  },

  mutations: {
    setLoading(state, value) {
      state.loading = value;
    },

    setError(state, err) {
      state.error = err;
    },

    setData(state, data) {
      state.data = data;
    },

    setMeta(state, meta) {
      state.meta = meta;
    },
  },

  getters: {
    loading: state => state.loading,
    error: state => state.error,
    cities: state => (state.data.dealers ? state.data.dealers.cities : []).sort((a, b) => {
      return a.title.localeCompare(b.title)
    }),
    sources: state => (state.data.dealers ? state.data.dealers.sources : []).sort((a, b) => {
      return a.title.localeCompare(b.title)
    }),
    statuses: state => (state.data.dealers ? state.data.dealers.statuses : []).sort((a, b) => {
      return a.title.localeCompare(b.title)
    }),
    meta: state => state.meta,
  },
};
